// extracted by mini-css-extract-plugin
export default {"carousel__container":"style_carousel__container__b6ZxI","item__container":"style_item__container__Vz0SL","carousel__item":"style_carousel__item__VndYF"};